module.exports = __webpack_public_path__ + "img/ape-constructor-hint.b398eae0.svg";